module.exports = __webpack_public_path__ + "img/nav_cr.b6be1896.svg";